import styled from 'styled-components'

export const Wrapper = styled.div`
  background-color: var(--gray-200);
  border-radius: var(--border-radius);
  overflow: hidden;
  position: relative;
  height: 19rem;

  img {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`

Wrapper.displayName = 'Wrapper'
